export default __webpack_public_path__ + "static/media/vyroba-naramkov.5b9dd651.svg";